module.exports = __webpack_public_path__ + "img/90.6605fdba.jpg";